import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

/**
 * BidSurveyTypeSchema
 */
export const [BidSurveyTypes, BidSurveyTypeSchema, BidSurveyTypeEnum] =
  EnumBuilder(
    'maker-bid-accepted-by-brand',
    'maker-bid-rejected-by-brand',
    'opportunity-to-bid-accepted-by-maker',
    'opportunity-to-bid-declined-by-maker'
  )

export type BidSurveyType = ZodInfer<typeof BidSurveyTypeSchema>

/**
 * LegacyQuickframeSurveyTypeSchema
 */
export const [
  LegacyQuickframeSurveyTypes,
  LegacyQuickframeSurveyTypeSchema,
  LegacyQuickframeSurveyTypeEnum,
] = EnumBuilder('legacy-quickframe-maker-rating')

export type LegacyQuickframeSurveyType = ZodInfer<
  typeof LegacyQuickframeSurveyTypeSchema
>

/**
 * ProjectSurveyTypeSchema
 */
export const [
  ProjectSurveyTypes,
  ProjectSurveyTypeSchema,
  ProjectSurveyTypeEnum,
] = EnumBuilder(
  'project-completed-brand-reviews-maker',
  'project-completed-maker-reviews-brand'
)

export type ProjectSurveyType = ZodInfer<typeof ProjectSurveyTypeSchema>

/**
 * SurveyTypeSchema
 */
export const [SurveyTypes, SurveyTypeSchema, SurveyTypeEnum] = EnumBuilder(
  ...BidSurveyTypes,
  ...LegacyQuickframeSurveyTypes,
  ...ProjectSurveyTypes
)

export type SurveyType = ZodInfer<typeof SurveyTypeSchema>
